module.exports = __webpack_public_path__ + "274049c725818099e931c1b64235b0a7.jpg";